export const GET_TASKLIST_REQUEST = 'GET_TASKLIST_REQUEST';
export const GET_TASKLIST_SUCCESS = 'GET_TASKLIST_SUCCESS';
export const GET_TASKLIST_FAILURE = 'GET_TASKLIST_FAILURE';
